import { AxiosResponse } from 'axios';
import { API } from 'config';
import {
  BODY_GENERATE_JOBS_AC,
  CREATE_ADJUSTMENT_SURCHARGE_PAYLOAD,
  EXTEND_JOB_AC_BODY,
  GET_ADJUSTMENT_SURCHARGE_PARAMS,
  GET_JOBS_PARAMS_REQUEST,
  JOB_AC_DETAIL_TYPE,
  JOB_DETAIL_TYPE,
  JOB_TRANSACTION_PARAMS_REQUEST,
  UPDATE_ADJUSTMENT_SURCHARGE_PAYLOAD,
  UPDATE_JOB_BODY,
  UPDATE_JOB_STATUS,
} from 'models';
import { AppAPIInstance } from 'services';

export const getJobsListApi = async (params?: GET_JOBS_PARAMS_REQUEST) => {
  return await AppAPIInstance.get(API.ADMIN.JOB.DEFAULT, {
    params,
  });
};

export const getJobDetailApi = async (
  id: string
): Promise<AxiosResponse<{ data: JOB_DETAIL_TYPE }>> => {
  return await AppAPIInstance.get(`${API.ADMIN.JOB.DEFAULT}/${id}`);
};

export const updateJobApi = async (id: string, data: UPDATE_JOB_BODY) => {
  return await AppAPIInstance.put(`${API.ADMIN.JOB.DEFAULT}/${id}`, data);
};

export const deleteJobApi = async (id: string) => {
  return await AppAPIInstance.delete(`${API.ADMIN.JOB.DEFAULT}/${id}`);
};

export const deleteAllJobApi = async (ids: string[]) => {
  const idsObj = {
    ids,
  };
  return await AppAPIInstance.delete(`${API.ADMIN.JOB.DEFAULT}/`, {
    data: idsObj,
  });
};

export const updateJobStatusApi = async (
  id: string,
  data?: UPDATE_JOB_STATUS
) => {
  return await AppAPIInstance.put(
    API.ADMIN.JOB.UPDATE_STATUS.replace(':id', id),
    data
  );
};

export const getJobsExportCSVApi = async (
  params?: Partial<GET_JOBS_PARAMS_REQUEST>
) => {
  return await AppAPIInstance.get(API.ADMIN.JOB.EXPORT, {
    params,
    responseType: 'blob',
  }).catch(async (e) => {
    return Promise.reject(
      JSON.parse((await e?.response?.data?.text()) || '{}')?.error
    );
  });
};

export const generateJobACApi = async (data: BODY_GENERATE_JOBS_AC) => {
  return await AppAPIInstance.post(`${API.ADMIN.JOB.GENERATE_AC}`, data);
};

export const getJobTransactionsApi = async (
  params?: JOB_TRANSACTION_PARAMS_REQUEST
) => {
  return await AppAPIInstance.get(API.ADMIN.JOB.TRANSACTION, {
    params,
  });
};
export const getACJobDetailApi = async (
  id: string
): Promise<AxiosResponse<{ data: JOB_AC_DETAIL_TYPE }>> => {
  return await AppAPIInstance.get(`${API.ADMIN.JOB.UPDATE_AC}/${id}`);
};

export const updateACJobApi = async (id: string, data: UPDATE_JOB_BODY) => {
  return await AppAPIInstance.put(`${API.ADMIN.JOB.UPDATE_AC}/${id}`, data);
};
export const cancelJobACApi = async (id: string) => {
  return await AppAPIInstance.patch(`${API.ADMIN.JOB.CANCEL_AC}/${id}`);
};

export const markCompleteJobACApi = async (id: string) => {
  return await AppAPIInstance.patch(`${API.ADMIN.JOB.MARK_COMPLETED_AC}/${id}`);
};

export const extendJobACApi = async (id: string, data: EXTEND_JOB_AC_BODY) => {
  return await AppAPIInstance.patch(`${API.ADMIN.JOB.EXTEND_AC}/${id}`, data);
};

export const canCreateTrialJob = async (data: {
  parent_id: string | undefined;
}) => {
  return await AppAPIInstance.post(
    API.CONCIERGE.JOBS.CAN_CREATE_TRIAL_JOB,
    data
  );
};

export const getAdjustmentSurchargeApi = async (
  params: GET_ADJUSTMENT_SURCHARGE_PARAMS
) => {
  return await AppAPIInstance.get(
    API.CONCIERGE.JOBS.ADJUSTMENT_SURCHARGE.LIST,
    {
      params,
    }
  );
};

export const addAdjustmentSurchargeApi = async (
  data: CREATE_ADJUSTMENT_SURCHARGE_PAYLOAD
) => {
  return await AppAPIInstance.post(
    API.CONCIERGE.JOBS.ADJUSTMENT_SURCHARGE.CREATE,
    data
  );
};

export const updateAdjustmentSurchargeApi = async (
  data: UPDATE_ADJUSTMENT_SURCHARGE_PAYLOAD
) => {
  return await AppAPIInstance.patch(
    API.CONCIERGE.JOBS.ADJUSTMENT_SURCHARGE.UPDATE,
    data
  );
};

export const deleteAdjustmentSurchargeApi = async (adjId: string) => {
  return await AppAPIInstance.delete(
    API.CONCIERGE.JOBS.ADJUSTMENT_SURCHARGE.DELETE(adjId)
  );
};
